import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import { SnackType } from '@/features/snacks/enums/SnackType';
import { getHelperTagsByEntity, getHelperTagsByEntitySuccess } from '@/domains/helperTags/store/helperTagsSlice';
import HttpService from '@/services/HttpService/HttpService';
import SnacksService from '@/services/SnackService/SnackService';

export function* getHelperTagsByEntitySaga({ payload }: PayloadAction<EdsEntityCodes>) {
  try {
    const { data } = yield call(
      HttpService.get,
      `/options/${payload}/HelperTags`,
      {},
      {
        baseURL: import.meta.env.VITE_API_URL_EDS,
      },
    );

    yield put(getHelperTagsByEntitySuccess({ entityType: payload, options: data?.[EdsEntityCodes.HelperTags] }));
  } catch (error) {
    console.error(error);
    SnacksService.add({
      type: SnackType.Error,
      title: 'Helper tags fetching error',
      content: 'Unable to fetch available helper tags. Please try again.',
      anchorOrigin: {
        horizontal: 'right',
        vertical: 'bottom',
      },
    });
  }
}

export function* helperTagsWatcher() {
  yield takeLatest([getHelperTagsByEntity.type], getHelperTagsByEntitySaga);
}
